import { ContentBox } from '../../ContentBox';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

type InputProps = {
  items: {
    key: string;
    element: ReactNode;
  }[];
  className?: string;
};

export const SimpleList = ({ items, className }: InputProps) => {
  return (
    <ContentBox className={className}>
      {items.map((item) => (
        <div key={item.key} className={styles.item}>
          {item.element}
        </div>
      ))}
    </ContentBox>
  );
};
